// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1bMwS","list":"PatternAutocomplete_list__1aNCq"};